/**
 * Turn a FastAPI error body into something a person can read.
 *
 * FastAPI returns `detail` as a plain string for HTTPException, but as an
 * ARRAY of error objects for request-validation failures (422). Now that the
 * API enforces field lengths and formats, 422s actually happen — and
 * `new Error(data.detail)` on an array renders as "[object Object]", which
 * tells a caregiver nothing about what to fix.
 */
export default function errorText(data, fallback = 'Something went wrong.') {
  const d = data && data.detail;

  if (typeof d === 'string' && d.trim()) return d;

  if (Array.isArray(d) && d.length) {
    const messages = d
      .map((item) => {
        if (typeof item === 'string') return item;
        const field = Array.isArray(item && item.loc)
          ? item.loc[item.loc.length - 1]
          : null;
        const msg = (item && item.msg) || '';
        if (!msg) return null;
        const label = typeof field === 'string' ? field.replace(/_/g, ' ') : null;
        return label ? `${label}: ${msg}` : msg;
      })
      .filter(Boolean);
    if (messages.length) return messages.join('. ');
  }

  if (data && typeof data.message === 'string' && data.message.trim()) {
    return data.message;
  }

  return fallback;
}
